export const checkIfFormDataChanged = (originalFormData, formData) => {
    return JSON.stringify(formData) !== JSON.stringify(originalFormData);
};
